/**
 * PaymentListPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Statistic,
} from 'components';
import { Button, DatePicker, Input, Select } from 'antd';
import moment from 'moment';
import { stringToMoneyFormat } from 'utils';

const PaymentListPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '결제 상태',
      form: [
        {
          input: (
            <Select
              size="large"
              placeholder={'전체'}
              options={[
                { label: '결제대기', value: '결제대기' },
                { label: '결제완료', value: '결제완료' },
                { label: '반품완료', value: '반품완료' },
                { label: '취소완료', value: '취소완료' },
                { label: '교환완료', value: '교환완료' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '기간',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '검색',
      form: [
        {
          input: (
            <Select
              size="large"
              placeholder={'전체'}
              options={[
                { label: '금액', value: '금액' },
                { label: '주문번호', value: '주문번호' },
                { label: '이름', value: '이름' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <Input
              size="large"
              style={{ ...styles.form.input.large }}
              placeholder="검색어를 입력해주세요"
            />
          ),
        },
      ],
    },
    {
      label: '플랫폼',
      form: [
        {
          input: (
            <Select
              size="large"
              placeholder={'전체'}
              options={[
                { label: 'CAFE24', value: 'CAFE24' },
                { label: '스마트스토어', value: '스마트스토어' },
              ]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  const newData = [
    {
      결제일: moment(),
      결제상태: '결제완료',
      금액: '32500',
      주문번호: '98765432198765',
      이름: '홍길동',
      결제수단: '네이버페이',
      플랫폼: '스마트스토어',
    },
  ];
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>결제 목록</Title>

          {/* 요약 */}
          <Content
            fullWidth
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40, display: 'flex' }}
          >
            {[
              { title: '전체', value: '0' },
              { title: '결제대기', value: '0' },
              { title: '결제완료', value: '0' },
              { title: '반품완료', value: '0' },
              { title: '취소완료', value: '0' },
              { title: '교환완료', value: '0' },
            ].map((_item, _index) => (
              <div
                key={`${_item.label}-${_index}`}
                style={{
                  background: '#FFFFFF',
                  borderRadius: 4,
                  width: `calc(100% / 6)`,
                  marginRight: _index === 7 ? 0 : 4,
                  padding: 20,
                }}
              >
                <Statistic
                  title={_item.title}
                  value={_item.value}
                  suffix={'건'}
                  direction={'row'}
                  style={{ justifyContent: 'center' }}
                />
              </div>
            ))}
          </Content>
          {/* 요약 끝 */}

          {/* 요약 */}
          {/* <Content
              maxWidth={'100%'}
              padding={0}
              backgroundColor={'none'}
              style={{ marginBottom: 40, display: 'flex' }}
            >
              {[
                { title: '입점 업체', value: 0, suffix: '업체' },
                { title: '입점 신청 업체', value: 0, suffix: '업체' },
                { title: '심사중인 업체', value: 0, suffix: '업체' },
                { title: '탈퇴한 업체', value: 0, suffix: '업체' },
              ].map((_item, _index) => (
                <div
                  key={`${_item.label}-${_index}`}
                  style={{
                    background: '#FFFFFF',
                    borderRadius: 4,
                    width: `calc(100% / 4)`,
                    marginRight: _index === 3 ? 0 : 4,
                    padding: 20,
                  }}
                >
                  <Statistic
                    title={_item.title}
                    value={_item.value}
                    suffix={_item.suffix}
                    direction={'row'}
                    style={{ justifyContent: 'center' }}
                  />
                </div>
              ))}
            </Content> */}
          {/* 요약 끝 */}

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{
                  ...styles.button,
                  background: 'var(--primary-color)',
                }}
              >
                검색
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색결과 */}
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
              검색 결과 총 <span>0</span>건
            </h4>
            <Table
              data={newData}
              columns={[
                {
                  title: '결제일시',
                  key: '결제일시',
                  render: (_item) =>
                    moment(_item).format('YYYY-MM-DD HH:mm:ss'),
                },
                {
                  title: '결제상태',
                  key: '결제상태',
                },
                {
                  title: '금액',
                  key: '금액',
                  render: (item) => stringToMoneyFormat(item),
                },
                {
                  title: '주문번호',
                  key: '주문번호',
                },
                {
                  title: '이름',
                  key: '이름',
                },
                {
                  title: '결제수단',
                  key: '결제수단',
                },
                {
                  title: '플랫폼',
                  key: '플랫폼',
                },
                {
                  title: '결제 상태',
                  key: '결제상태',
                  render: (_, record) => (
                    <Select
                      size="medium"
                      placeholder={record.결제상태}
                      options={[
                        { label: '결제대기', value: '결제대기' },
                        { label: '결제완료', value: '결제완료' },
                        { label: '반품완료', value: '반품완료' },
                        { label: '취소완료', value: '취소완료' },
                        { label: '교환완료', value: '교환완료' },
                      ]}
                      style={{ ...styles.form.input.medium }}
                    />
                  ),
                },
                {
                  title: '저장',
                  key: 'save',
                  width: '70px',
                  render: (_, record) => <Button>저장</Button>,
                },
              ]}
            />
          </Content>
          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default PaymentListPresenter;
